import { useState, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import { ReactBarcode } from 'react-jsbarcode';
import { dateFormatter } from "@utils/dateFormatter";
import { useLiffContext } from "@/apps/@components/liff-context";
import QRCode from "react-qr-code";
import { LoadingOverlay } from "@/apps/@components/loading-overlay";

const ProfilePage = ({ viewportHeight }) => {
	const mail = "cs_taiwan@toryburch.com.";
	const { liffState } = useLiffContext();
	const { profile } = liffState;
	const [qrCodeOpened, setQrCodeOpened] = useState(false);
	
	const [containerClass, setContainerClass] = useState("");
	const [titleClass, setTitleClass] = useState("");
	const [codeClass, setCodeClass] = useState("");
	const [dataListClass, setDataListClass] = useState("");
	const [labelClass, setLabelClass] = useState("");
	const [contentClass, setContentClass] = useState("");
	const [contactMessageClass, setContactMessageClass] = useState("");
	const [contactEmailClass, setContactEmailClass] = useState("");
	const [errorClass, setErrorClass] = useState("");
	const [tryLaterClass, setTryLaterClass] = useState("");


	const handleResize = () => {
		if (window.innerWidth > 640) {
			setContainerClass("px-[112px] flex flex-col items-center");
			setTitleClass("w-[169px]");
			setCodeClass(
				"text-[19px] bai-jamjuree-semibold tracking-[5px] leading-4",
			);
			setDataListClass("w-full mt-16 space-y-14");
			setLabelClass(
				"text-[#777777] noto-sans-tc-medium text-[17px] tracking-wider",
			);
			setContentClass(
				"uppercase kumbh-sans-medium text-[24px] tracking-widest",
			);
			setContactMessageClass("text-[17px] font-medium whitespace-nowrap mt-24");
			setContactEmailClass(
				"text-[17px] kumbh-sans-medium mt-2 border-b border-black",
			);
			setErrorClass("w-[292px] h-auto mt-[160px]");
			setTryLaterClass("w-[366px] h-auto mt-[160px]");
		} else {
			setContainerClass("px-[7.5vw] flex flex-col h-full items-center");
			setTitleClass("w-[26vw]");
			setContactMessageClass("text-[3.28vw] font-medium whitespace-nowrap mt-[14vw]");
			setErrorClass("w-[46vw] h-auto mt-[40vw]");
			setTryLaterClass("w-[57vw] h-auto mt-[40vw]");
			if (window.innerWidth > 460 && window.innerWidth <= 640) {
				setCodeClass(
					"text-[19px] bai-jamjuree-semibold tracking-[5px] leading-4",
				);
				setDataListClass("w-full mt-16 space-y-9 break-all");
				setLabelClass(
					"text-[#777777] noto-sans-tc-medium text-[17px] tracking-wider",
				);
				setContentClass(
					"uppercase kumbh-sans-medium text-[24px] tracking-widest",
				);
				setContactEmailClass(
					"text-[16px] mt-[1vw] kumbh-sans-medium border-b border-black",
				);
			} else if (window.innerWidth > 390 && window.innerWidth <= 460) {
				setCodeClass(
					"text-[14px] bai-jamjuree-semibold tracking-[4px] leading-4",
				);
				setDataListClass("w-full mt-16 space-y-7 break-all");
				setLabelClass(
					"text-[#777777] noto-sans-tc-medium text-[13px] tracking-wider",
				);
				setContentClass(
					"uppercase kumbh-sans-medium text-[17px] tracking-widest",
				);
				setContactEmailClass(
					"text-[15px] mt-[1vw] kumbh-sans-medium border-b border-black",
				);
			} else {
				setCodeClass(
					"text-[13px] bai-jamjuree-semibold tracking-[3px] leading-4",
				);
				setDataListClass("w-full mt-16 space-y-7 break-all");
				setLabelClass(
					"text-[#777777] noto-sans-tc-medium text-[11px] tracking-wider",
				);
				setContentClass(
					"uppercase kumbh-sans-medium text-[15px] tracking-widest",
				);
				setContactEmailClass(
					"text-[13px] mt-[1vw] kumbh-sans-medium border-b border-black",
				);
			}
		}
	};

	useLayoutEffect(() => {
		window.addEventListener("resize", handleResize);
		handleResize();

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return (
		<div
			className={containerClass}
			style={{
				height: viewportHeight,
				position: "relative",
			}}
		>
			<LoadingOverlay visible={!profile.ready} />
			{profile.ready && (
				<>
					<img
						alt={"title"}
						className={titleClass}
						src={window.assetUrl(
							"/images/liff/profile-page/title.png",
						)}
					/>
					<img
						src={window.assetUrl("/images/liff/profile-page/qrcode-icon.png")}
						alt="qrcode"
						className="mt-[0.9rem] absolute top-[-4rem] right-[1.25rem] w-[1.5rem] h-[1.5rem]"
						onClick={() => setQrCodeOpened(true)}
					/>
					<ReactBarcode
						className="w-full mt-2"
						value={profile.data.vip_code}
						options={{width:3,height:110,displayValue: false}}
					/>
					<p className={codeClass}>{profile.data.vip_code}</p>
					<dl className={dataListClass}>
						<div>
							<dt className={labelClass}>姓名</dt>
							<dd className={contentClass}>{profile.data.name}</dd>
						</div>
						<div>
							<dt className={labelClass}>生日</dt>
							<dd className={contentClass}>{dateFormatter(profile.data.birthday)}</dd>
						</div>
						<div>
							<dt className={labelClass}>電話號碼</dt>
							<dd className={contentClass}>
								{profile.data?.mobile && profile.data.mobile.startsWith('0') ? 
									profile.data?.mobile : '0' + profile.data?.mobile
								}
							</dd>
						</div>
						{profile.data.email &&
							<div>
								<dt className={labelClass}>電郵</dt>
								<dd className={contentClass}>{profile.data.email}</dd>
							</div>
						}
					</dl>
					<div className={"flex flex-col items-center justify-center"}>
						<label className={contactMessageClass}>如需更改個人資訊，請發送電子郵件至</label>
						<a href={"mailto:" + mail} className={contactEmailClass}>
							{mail}
						</a>
					</div>{" "}
				</>
			)}
			{!profile.ready && (
				<div className={"flex grow flex-col items-center justify-between"}>
					<img
						alt={"loading"}
						className={errorClass}
						src={window.assetUrl(
							"/images/liff/profile-page/error.png",
						)}
						style={{
							marginTop: profile.ready ? "" : "",
						}}
					/>
					<img
						alt={"reload"}
						className={tryLaterClass}
						src={window.assetUrl(
							"/images/liff/profile-page/try-later.png",
						)}
						style={{
							marginTop: profile.ready ? "" : "",
						}}
					/>
				</div>
			)}

			{qrCodeOpened && createPortal(
				<div className="bg-[#DFDFDFCC] absolute bottom-0 left-0 right-0 w-full h-svh flex justify-center items-center">
					<div className="bg-[#FFFFFF] w-[80%] h-[70%] min-w-[20rem] max-h-[25rem] rounded-[10px] flex flex-col items-center justify-center p-7 shadow-xl relative">
						<span className="absolute top-0 right-0 p-2 px-4 text-[15px]" onClick={() => setQrCodeOpened(false)}>X</span>
						<div className="flex flex-col items-center justify-center">
							<QRCode value={profile.data.vip_code} className="w-[12.5rem] h-[12.5rem] bg-white p-1 rounded-md" />
							<p className="text-[0.75rem] bai-jamjuree-semibold tracking-[4px] leading-4 mt-6">{profile.data.vip_code}</p>
						</div>
					</div>
				</div>
			, document.getElementById("root"))}
		</div>
	);
};

export default ProfilePage;
